import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutesNew from './routes/AppRoutesNew';

function App() {
  return (
    <Router>
      <AppRoutesNew />
    </Router>
  );
}

export default App;
